import { render, staticRenderFns } from "./LiveQuizEditorDialog.vue?vue&type=template&id=3c7c6b80&scoped=true"
import script from "./LiveQuizEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveQuizEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveQuizEditorDialog.vue?vue&type=style&index=0&id=3c7c6b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c6b80",
  null
  
)

export default component.exports